module.exports = __webpack_public_path__ + "img/perro.44d73613.svg";